import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';

import { selectingPendingInstallation } from '@app/redux/pendingInstallation';
import { selectPlanCharacteristics } from '@app/redux/plan';

import loadingStyles from './Loading.module.scss';

export const PlanName = () => {
  const { hasPendingInstallation } = useSelector(selectingPendingInstallation);

  const {
    characteristics: { name },
    loading,
  } = useSelector(selectPlanCharacteristics);

  if (loading) {
    return <div className={loadingStyles['planName']} />;
  }

  if (!name) {
    return null;
  }

  return (
    <Txt variant={'bodySmallBold'} mt={hasPendingInstallation ? '24px' : undefined}>
      {name}
    </Txt>
  );
};
